/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { Button } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import _map from 'lodash/map';

import {
  useGetMany,
  useDataProvider,
  useRefresh,
  useNotify,
  useUnselectAll,
} from 'react-admin';
import { STATUS } from '../helpers/constants';

const BulkPublishButton = (props) => {
  const { data } = useGetMany(props.resource, props.selectedIds);

  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const dataProvider = useDataProvider();

  const handleClick = async () => {
    const sources = _map(data, (source) => ({
      ...source,
      status: STATUS.PUBLISHED,
    }));

    try {
      await dataProvider.updateMany(props.resource, {
        [props.resource]: sources,
      });
      unselectAll(props.resource);
      notify(`${props.resource}' status changed to 'published'`);
      refresh();
    } catch (error) {
      notify(`Unable to publish, ${error.message}`, 'warning');
    }
  };

  return (
    <Button color="secondary" size="small" onClick={handleClick}>
      <PublishIcon />
      Publish
    </Button>
  );
};

export default BulkPublishButton;
